import { createAsyncThunk } from '@reduxjs/toolkit';
import FeatureFlagsAPI from './featureFlagsApi';

export const fetchFeatureFlagsThunk = createAsyncThunk(
  'featureFlags/fetchFlags',
  async (_, { rejectWithValue }) => {
    try {
      return await FeatureFlagsAPI.fetchFlags();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load feature flags');
    }
  }
);

export const fetchFeatureFlagsAdminThunk = createAsyncThunk(
  'featureFlags/fetchFlagsAdmin',
  async (_, { rejectWithValue }) => {
    try {
      return await FeatureFlagsAPI.fetchFlagsAdmin();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load feature flags');
    }
  }
);

export const createFeatureFlagThunk = createAsyncThunk(
  'featureFlags/createFlag',
  async (flagData, { rejectWithValue }) => {
    try {
      return await FeatureFlagsAPI.createFlag(flagData);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to create feature flag');
    }
  }
);

export const updateFeatureFlagThunk = createAsyncThunk(
  'featureFlags/updateFlag',
  async ({ name, updates }, { rejectWithValue }) => {
    try {
      return await FeatureFlagsAPI.updateFlag(name, updates);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to update feature flag');
    }
  }
);

export const deleteFeatureFlagThunk = createAsyncThunk(
  'featureFlags/deleteFlag',
  async (name, { rejectWithValue }) => {
    try {
      return await FeatureFlagsAPI.deleteFlag(name);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to delete feature flag');
    }
  }
);
